<template>
  <div
    class="save-preset"
    @keydown.stop.enter="apply"
  >
    <GwInput
      :label="$t('common.name')"
      style="--input-height: 2.5rem"
      type="text"
      autofocus
      :getErrors="
        () => (nameError ? [$t(`messages.${nameError}`, { max_chars: nameMaxChars })] : [])
      "
      :value="l_item.name"
      @input="(_e, value) => (l_item.name = value)"
      @keydown:enter="apply"
    />
    <GwInput
      class="mt-4"
      :label="$t('common.note')"
      :isTextArea="true"
      :getErrors="
        () =>
          descriptionError
            ? [$t(`messages.${descriptionError}`, { max_chars: descriptionMaxChars })]
            : []
      "
      :value="l_item.description"
      @input="(_e, value) => (l_item.description = value)"
      @keydown:enter="apply"
    />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import GwInput from '@/components/lib/GwInput'

export default {
  name: 'TableFilterSave',
  components: { GwInput },
  mixins: [format_mix],
  props: {},
  data() {
    return {
      l_item: null,
      nameError: false,
      descriptionError: false,
      nameMaxChars: 200,
      descriptionMaxChars: 500,
    }
  },
  created() {
    this.l_item = { ...this.$store.getters.fss_selected_filter }
  },
  methods: {
    getNameError() {
      let res = false
      this.nameError = false
      // this.l_item.name = this.l_item.name.trim()
      if (this.l_item.name.trim().length > this.nameMaxChars) {
        this.nameError = 'field_name_too_many_characters'
        res = true
      }
      return res
    },
    getDescriptionError() {
      let res = false
      this.descriptionError = false
      // this.l_item.description = this.l_item.description.trim()
      if (this.l_item.description.trim().length > this.descriptionMaxChars) {
        this.descriptionError = 'field_description_too_many_characters'
        res = true
      }
      return res
    },
    apply() {
      const filterCall = this.$store.getters.api_get('api_poker_saved_filter')
      if (['post', 'put'].includes(filterCall.method) && filterCall.loading) return

      if (this.getNameError()) return
      if (this.getDescriptionError()) return
      if (!this.l_item.name.trim().length) {
        this.nameError = 'field_name_empty_error'
        return
      }

      const { id } = this.l_item
      const item = {
        id,

        name: this.l_item.name.trim(),
        description: this.l_item.description.trim(),

        favorite: !!this.l_item.favorite,
        filter_type: this.l_item.filter_type,
        query: this.l_item.query,
      }
      this.$store.dispatch('fss_setFilter', {
        item,
        hasMessage: true,
        method: id ? 'PUT' : 'POST',
      })
    },
  },
}
</script>

<style lang="scss">
.save-preset {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  // width: 32rem;
  min-height: 15.5rem;
  max-width: 100%;
  // kinda hacky but works
  min-width: clamp(1px, 32rem, calc(100vw - 2rem));
  max-width: 100%;
}
</style>
